export function postEventOverlay(apiClient, eventId, overlayTemplateId) {
  return apiClient.post(`/api/events/${eventId}/overlay`, {
    overlayTemplateId: overlayTemplateId ?? null
  });
}
